import { render } from "./TestimonialPage.vue?vue&type=template&id=b1a1fc98"
import script from "./TestimonialPage.vue?vue&type=script&lang=js"
export * from "./TestimonialPage.vue?vue&type=script&lang=js"

import "./TestimonialPage.vue?vue&type=style&index=0&id=b1a1fc98&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__